<template>
  <div class="table-box">
    <table>
      <td v-for="(item, index) in detail" :key="index">
        <tr>
          <!-- <td v-if="index == 0" class="table-value" >团队角色</td> -->
          <!-- 表名字（正常） -------------------没有人知道为了改这个UI 做了多少种恶心情况的判断-------------------------------------------------->
          <td
            v-if="
              item.name == '实干者' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color1"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '协调者' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color2"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '推进者' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color3"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '创新者' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color4"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '信息者' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color5"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '监督者' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color6"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '凝聚者' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color7"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '完善者' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color8"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '专家型' &&
              (item.score != maxScore || item.score == 0)
            "
            class="color9"
          >
            {{ item.name }}
          </td>

          <!-- 表名字（最大||最小） --------------------------------------------------------------------->
          <td
            v-if="
              item.name == '实干者' && item.score == maxScore && item.score != 0
            "
            class="color11"
          >
            <span>{{ item.name }}</span>
          </td>
          <td
            v-if="
              item.name == '协调者' && item.score == maxScore && item.score != 0
            "
            class="color22"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '推进者' && item.score == maxScore && item.score != 0
            "
            class="color33"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '创新者' && item.score == maxScore && item.score != 0
            "
            class="color44"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '信息者' && item.score == maxScore && item.score != 0
            "
            class="color55"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '监督者' && item.score == maxScore && item.score != 0
            "
            class="color66"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '凝聚者' && item.score == maxScore && item.score != 0
            "
            class="color77"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '完善者' && item.score == maxScore && item.score != 0
            "
            class="color88"
          >
            {{ item.name }}
          </td>
          <td
            v-if="
              item.name == '专家型' && item.score == maxScore && item.score != 0
            "
            class="color99"
          >
            {{ item.name }}
          </td>
        </tr>

        <tr>
          <!-- <td v-if="index == 0" class="table-value">分值</td> -->
          <!-- 分数（正常） --------------------------------------------------------------------->
          <td
            v-if="
              item.name == '实干者' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <td
            v-if="
              item.name == '协调者' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <td
            v-if="
              item.name == '推进者' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <td
            v-if="
              item.name == '创新者' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <td
            v-if="
              item.name == '信息者' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <td
            v-if="
              item.name == '监督者' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <td
            v-if="
              item.name == '凝聚者' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <td
            v-if="
              item.name == '完善者' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <td
            v-if="
              item.name == '专家型' &&
              item.score != maxScore &&
              item.score != minScore
            "
            class="table-value1"
          >
            {{ item.score }}
          </td>
          <!-- 分数（最大||最小） --------------------------------------------------------------------->
         
          <td
            v-if="item.name == '实干者' && item.score == maxScore && IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

          <td
            v-if="item.name == '实干者' && item.score == minScore && IsTeamZero == false"
            class="table-value3"
          >
            <span v-if="item.score == minScore ">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>


           <td
            v-if="item.name == '实干者' && item.score == minScore && IsTeamZero == true"
            class="table-value2"
          >
            <span v-if="item.score == minScore ">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>
        
          <td
            v-if="item.name == '协调者' && item.score == maxScore && IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

          <td
            v-if="item.name == '协调者' && item.score == minScore && IsTeamZero == false"
            class="table-value3"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>
           <td
            v-if="item.name == '协调者' && item.score == minScore && IsTeamZero == true"
            class="table-value2"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>
         
          <td
            v-if="item.name == '推进者' && item.score == maxScore&& IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

          <td
            v-if="item.name == '推进者' && item.score == minScore  && IsTeamZero == false"
            class="table-value3"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

            <td
            v-if="item.name == '推进者' && item.score == minScore  && IsTeamZero == true"
            class="table-value2"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>




          <td
            v-if="item.name == '创新者' && item.score == maxScore&& IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

          <td
            v-if="item.name == '创新者' && item.score == minScore && IsTeamZero == false"
            class="table-value3"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>


          <td
            v-if="item.name == '创新者' && item.score == minScore && IsTeamZero == true"
            class="table-value2"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>



          

          <td
            v-if="item.name == '信息者' && item.score == maxScore&& IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

          <td
            v-if="item.name == '信息者' && item.score == minScore&& IsTeamZero == false"
            class="table-value3"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

           <td
            v-if="item.name == '信息者' && item.score == minScore&& IsTeamZero == true"
            class="table-value2"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>
          
         
          <td
            v-if="item.name == '监督者' && item.score == maxScore&& IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

          <td
            v-if="item.name == '监督者' && item.score == minScore && IsTeamZero == false"
            class="table-value3"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>


           <td
            v-if="item.name == '监督者' && item.score == minScore && IsTeamZero == true"
            class="table-value2"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

        
          <td
            v-if="item.name == '凝聚者' && item.score == maxScore&& IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

          <td
            v-if="item.name == '凝聚者' && item.score == minScore && IsTeamZero == false"
            class="table-value3"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>


            <td
            v-if="item.name == '凝聚者' && item.score == minScore && IsTeamZero == true"
            class="table-value2"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

         
          <td
            v-if="item.name == '完善者' && item.score == maxScore&& IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

          <td
            v-if="item.name == '完善者' && item.score == minScore&& IsTeamZero == false"
            class="table-value3"
            
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>

           <td
            v-if="item.name == '完善者' && item.score == minScore&& IsTeamZero == true"
            class="table-value2"
            
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>




         
          <td
            v-if="item.name == '专家型' && item.score == maxScore && IsTeamZero == false"
            class="table-value2"
          >
            <span v-if="item.score == maxScore && IsTeamZero == false">
              <span style="color: #2cbcb9; font-size: 25px"
                >{{ item.score }}
              </span>
            </span>
            <div>
              <img
                v-if="item.score == maxScore && IsTeamZero == false"
                :src="images.shan1"
                style="height: auto; width: 50%"
              />
            </div>


            
          </td>

          <td
            v-if="item.name == '专家型' && item.score == minScore && IsTeamZero == false"
            class="table-value3"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>


           <td
            v-if="item.name == '专家型' && item.score == minScore  && IsTeamZero == true"
            class="table-value2"
          >
            <span v-if="item.score == minScore">
              <span style="color: #f72827">{{ item.score }} </span>
            </span>
            <div>
              <img
                v-if="item.score == minScore"
                :src="images.shan2"
                style="height: auto; width: 50%"
              />
            </div>
          </td>
        </tr>
      </td>
    </table>
  </div>
</template>

<script>
export default {
  props: [
    "result",
    "detail",
    "maxScore",
    "minScore",
    "maxName",
    "title",
    "IsTeamZero",
  ],
  data() {
    return {
      images: {
        shan1: require("../../../../assets/images/team/shan1.png"),
        shan2: require("../../../../assets/images/team/shan2.png"),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.table-box {
  margin: 0px auto;
  table {
    padding-top: 8px;
    width: 100%;
    border: none;
    // padding-left:50px;
    border-spacing: 2.5px;
  }
  //正常
  // .table-value {
  //   width: 240px;
  //   // height: 65px;
  //   padding: 20px 10px 20px 10px;
  //   font-size: 15px;
  //   text-align: center;
  //   font-weight: bold;
  //   // background-color: #e4e5ea;
  // }
  //正常
  .table-value1 {
    width: 120px;
    // height: 65px;
    padding: 8px 10px 8px 10px;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    background-color: white;
  }
  //最大最小
  .table-value2 {
    width: 120px;
    padding: 1px 10px 1px 10px;
    // height: 70px;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    background-color: white;
  }
  .table-value3 {
    width: 120px;
    padding: 7px 10px 0 10px;
    // height: 70px;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    background-color: white;
    // background-color: #e4e5ea;
  }
  // .color0 {
  //   width: 150px;
  //   //  height: 31px;
  //   padding: 4px 0 4px 0;
  //   font-weight: bold;
  //   text-align: center;
  //   font-size: 13px;

  //   background-color: #e4e5ea;
  //   color: black;
  // }
  .color1 {
    width: 120px;
    padding: 4px 0 4px 0;
    font-weight: bold;
    text-align: center;
    font-size: 13px;
    background-color: #fc5c64;
    color: white;
  }
  .color2 {
    width: 120px;
    padding: 4px 0 4px 0;
    font-weight: bold;
    text-align: center;
    font-size: 13px;
    background-color: #778ca2;
    color: white;
  }
  .color3 {
    width: 120px;

    padding: 4px 0 4px 0;
    font-weight: bold;
    text-align: center;
    font-size: 13px;
    background-color: #a65eea;
    color: white;
  }
  .color4 {
    width: 120px;

    padding: 4px 0 4px 0;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    background-color: #4b7aed;
    color: white;
  }
  .color5 {
    width: 120px;

    padding: 4px 0 4px 0;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    background-color: #44aaf2;
    color: white;
  }
  .color6 {
    width: 120px;

    padding: 4px 0 4px 0;
    font-weight: bold;
    font-size: 13px;
    text-align: center;
    background-color: #2acbba;
    color: white;
  }
  .color7 {
    width: 120px;

    padding: 4px 0 4px 0;
    // padding:20px;
    top: 10px;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    background-color: #50db95;
    color: white;
  }
  .color8 {
    width: 120px;
    font-size: 13px;
    padding: 4px 0 4px 0;
    font-weight: bold;
    text-align: center;
    background-color: #facd58;
    color: white;
  }
  .color9 {
    width: 120px;
    font-size: 13px;
    padding: 4px 0 4px 0;
    font-weight: bold;
    text-align: center;
    background-color: #fd9544;
    color: white;
  }

  .color11 {
    width: 120px;
    // height: 30px;
    padding: 9px 0 4px 0;
    font-weight: bold;
    text-align: center;
    font-size: 13px;
    background-color: #fc5c64;
    color: white;
  }

  .color22 {
    width: 120px;
    // height: 30px;
    padding: 9px 0 4px 0;;
    font-weight: bold;
    text-align: center;
    font-size: 13px;
    background-color: #778ca2;
    color: white;
  }
  .color33 {
    width: 120px;
    // height: 30px;
    padding: 9px 0 4px 0;;
    font-weight: bold;
    text-align: center;
    font-size: 13px;
    background-color: #a65eea;
    color: white;
  }
  .color44 {
    width: 120px;
    // height: 30px;
    padding: 9px 0 4px 0;;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    background-color: #4b7aed;
    color: white;
  }
  .color55 {
    width: 120px;
    // height: 30px;
    padding: 9px 0 4px 0;;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    background-color: #44aaf2;
    color: white;
  }
  .color66 {
    width: 120px;
    // height: 30px;
    padding: 9px 0 4px 0;;
    font-weight: bold;
    font-size: 13px;
    text-align: center;
    background-color: #2acbba;
    color: white;
  }
  .color77 {
    width: 120px;
    // height: 30px;
    padding: 9px 0 4px 0;;
    // padding:20px;
    top: 10px;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    background-color: #50db95;
    color: white;
  }
  .color88 {
    width: 120px;
    font-size: 13px;
    // height: 31px;
    height: 30px;
    padding: 9px 0 4px 0;;

    font-weight: bold;
    text-align: center;
    background-color: #facd58;
    color: white;
  }
  .color99 {
    width: 120px;
    font-size: 13px;
    // height: 31px;
    height: 30px;
    padding: 9px 0 4px 0;;
    font-weight: bold;
    text-align: center;
    background-color: #fd9544;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/table/all/TuanDetail.vue